export const RANK_TEXTS = {
  gold: "ゴールド",
  silver: "シルバー",
  bronze: "ブロンズ",
  normal: "平均的な",
  potential: "のびしろのある",
};

export const RESULT_SUB_TEXT = {
  gold: "業界でもごく一部のトップ層です。実績を活かし、業界を代表する存在として活躍していきましょう。",
  silver:
    "安定して高い成果を出せています。自分の強みをさらに磨き、トップ層を目指していきましょう。",
  bronze:
    "実力が着実に積み上がっています。成功の理由を振り返り、売上につながる力を伸ばしていきましょう。",
  normal:
    "これから伸ばせる要素が多い段階です。基本を磨き、売上力を高める準備を進めていきましょう。",
  potential:
    "大きく成長できるポテンシャルがあります。基礎を固め、売上力の土台を育てていきましょう。",
};

export const COMMON_PROBLEMS = {
  numberOfCustomers: [
    "引き出しの数・応用力を身に付けたい",
    "収入UPにつなげたい",
    "売上や集客力が欲しい",
  ],
  averageNominationRatio: ["自信につなげたい", "自分の信用・実力を確かめたい"],
  averageCustomerSpending: ["効率的に働きたい", "こだわって施術ができない", "指名が増えない"],
  averagePersonalSales: [
    "なかなか収入が上がらない",
    "将来のキャリアに安心感が欲しい",
    "自信・モチベーションが欲しい",
  ],
};

export const SEARCH_SUGGESTIONS = {
  numberOfCustomers: ["インセンティブあり", "駅近", "副業・WワークOK"],
  averageNominationRatio: ["研修制度あり", "高級サロン", "客単価10,000円以上"],
  averageCustomerSpending: ["客単価10,000円以上", "客単価5,000円以上", "高級サロン"],
  averagePersonalSales: ["研修制度あり", "大手サロン", "ノルマなし"],
};
